import { Component, inject } from '@angular/core';

import { ThemeColorService } from '@tk/shared/lib';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent {
  private readonly themeColorService = inject(ThemeColorService);

  constructor() {
    if (navigator.userAgent.includes('Win')) {
      document.body.classList.add('scrollbar-win'); // see {@link '../scss/taikun/scrollbar'}
    }
  }
}
